import React from 'react'
import { ExternalLink } from 'lucide-react'

interface QuickAccessCardProps {
  title: string
  description: string
  url?: string
  links?: Array<{
    label: string
    url: string
  }>
  icon: React.ComponentType<any>
  category: string
  color: string
}

const QuickAccessCard: React.FC<QuickAccessCardProps> = ({
  title,
  description,
  url,
  links,
  icon: Icon,
  category,
  color
}) => {
  const handleClick = () => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer')
    }
  }

  const handleLinkClick = (linkUrl: string, e: React.MouseEvent) => {
    e.stopPropagation()
    window.open(linkUrl, '_blank', 'noopener,noreferrer')
  }

  return (
    <div 
      className={`card p-6 hover:shadow-lg transition-all duration-200 group ${url ? 'cursor-pointer' : ''}`}
      onClick={handleClick}
    >
      <div className="flex items-start justify-between mb-4">
        <div className={`w-12 h-12 ${color} rounded-lg flex items-center justify-center`}>
          <Icon className="w-6 h-6 text-white" />
        </div>
        <ExternalLink className="w-4 h-4 text-gray-400 group-hover:text-gray-600 transition-colors" />
      </div>
      
      <div className="mb-3">
        <h3 className="text-lg font-semibold text-gray-900 mb-1 group-hover:text-grace-blue-600 transition-colors">
          {title}
        </h3>
        <p className="text-sm text-gray-600 leading-relaxed">
          {description}
        </p>
      </div>
      
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium text-gray-500 bg-gray-100 px-2 py-1 rounded-full">
          {category}
        </span>
        {links ? (
          <div className="flex space-x-2">
            {links.map((link, index) => (
              <button
                key={index}
                onClick={(e) => handleLinkClick(link.url, e)}
                className="text-xs bg-grace-blue-100 text-grace-blue-700 px-2 py-1 rounded-full hover:bg-grace-blue-200 transition-colors"
              >
                {link.label}
              </button>
            ))}
          </div>
        ) : (
          <span className="text-xs text-gray-400 group-hover:text-gray-600 transition-colors">
            Click to open
          </span>
        )}
      </div>
    </div>
  )
}

export default QuickAccessCard 